import script from "./CurrentNurse.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentNurse.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentNurse.vue?vue&type=style&index=0&id=73912887&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73912887"]])

export default __exports__